/***
 *Â @FileName: é£ä¹¦ä¸»é¢
 *Â @Author: manyao.zhu
 *Â @Date: 2020-06-10 16:32:49
 */
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { SettingsService, StoreService } from '@ithinkdt/shared/browser';
import { UrlChangeService } from '@ithinkdt/shared/route';
import { ThemeConfig } from '@ithinkdt/theme/models';

import { MENU_CONFIG } from './feishu-theme.config';

@Component({
  selector: 'dt-feishu-theme',
  templateUrl: './feishu-theme.component.html',
  styleUrls: ['./feishu-theme.component.scss'],
})
export class FeishuThemeComponent implements OnInit {
  themeConfig: ThemeConfig;

  menuData = MENU_CONFIG;

  constructor(
    private settingSrv: SettingsService,
    private urlChangeSrv: UrlChangeService,
    private storeSrv: StoreService,
    private router: Router
  ) {
    this.themeConfig = this.settingSrv.userConfig['theme'] || {};
    this.handleHideMenu();
    this.jumpAppointRouter();
  }

  ngOnInit() {}

  // å¤çé¡µé¢æ¯å¦æ¾ç¤ºèå
  handleHideMenu() {
    const isHide = this.urlChangeSrv.getParam('hideMenu');
    if (isHide) {
      this.settingSrv.setHideMenu(isHide);
    }
    const hideMenu = this.settingSrv.hideMenu;
    if (isHide || hideMenu) {
      this.themeConfig.hidenMenu = true;
    }
  }

  // å¤çè·³è½¬(å¨æ°é¡µé¢æå¼æ¶ä½¿ç¨)
  jumpAppointRouter() {
    const url = this.storeSrv.get('jumpRouter');
    if (!url) {
      return;
    }
    const route = url.slice(0, url.indexOf('?'));
    const param = url.slice(url.indexOf('?') + 1, url.length);
    const params = {};
    const arr = param.split('&');
    arr.forEach((item) => {
      const key = item.split('=')[0];
      const val = item.split('=')[1];
      if (key !== 'jumpToken') {
        params[key] = val;
      }
    });
    setTimeout(() => {
      this.router.navigate([route], { queryParams: params });
    }, 0);
  }
}
